export default __webpack_public_path__ + "static/demo-a46255eb1cf4e2357c6093e9c17b95e6.gif";